import { Canvas, CanvasHandles } from "@/ui/shared/Canvas.tsx";
import { Button, Image, SegmentedControl, Slider, Text } from "@mantine/core";
import { useElementSize } from "@mantine/hooks";
import { useRef, useState } from "react";

type PhotoMarkerProps = {
  inputUrl?: string | null;
  setMask: (mask: Blob) => void;
};

export function PhotoMarker({ inputUrl, setMask }: PhotoMarkerProps) {
  const [brushSize, setBrushSize] = useState(15);
  const [isErasing, setIsErasing] = useState(false);
  const canvasRef = useRef<CanvasHandles>(null);
  const { ref: elementSizeRef, width, height } = useElementSize();

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col justify-center relative">
        <Image
          ref={elementSizeRef}
          radius="md"
          src={inputUrl}
          alt="Image source"
        />

        <div className="absolute top-0 left-0 flex items-stretch">
          <Canvas
            ref={canvasRef}
            width={width}
            height={height}
            isErasing={isErasing}
            brushSize={brushSize}
            setMask={setMask}
          />
        </div>
      </div>

      <div className="flex flex-col items-center gap-2">
        <div className="flex flex-col gap-0.5 w-full">
          <Text fw={500} size="md" component="label" mb={0}>
            Brush size
          </Text>

          <Slider
            size="lg"
            value={brushSize}
            onChange={setBrushSize}
            min={1}
            max={100}
          />
        </div>

        <div className="flex flex-col gap-0.5 w-full">
          <Text fw={500} size="md" component="label" mb={0}>
            Mode
          </Text>

          <SegmentedControl
            size="sm"
            color="violet"
            value={isErasing ? "erase" : "draw"}
            onChange={(value) => setIsErasing(value === "erase")}
            data={[
              {
                label: "Draw",
                value: "draw",
              },
              {
                label: "Erase",
                value: "erase",
              },
            ]}
            fullWidth
          />
        </div>
      </div>

      <Button
        fullWidth
        variant="default"
        onClick={canvasRef.current?.handleClear}
      >
        Reset
      </Button>
    </div>
  );
}
